import React from "react"
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'


const CitationEditor = ({ citation, handleChange }) => {

    const modules = {
        toolbar: [
            ['italic', 'bold']
        ]
    }
    const formats = ['italic', 'bold']


    return (
        <ReactQuill
                modules={modules}
                formats={formats}
                defaultValue={citation}
                value={citation}
                theme="snow"
                placeholder="Enter citation"
                onChange={handleChange}
                style={{backgroundColor: "white"}}
        />
    )
}

export default CitationEditor


// WEBPACK FOOTER //
// ./src/routes/publications/components/CitationEditor.js